import i18n from 'i18n';

const invalidChars = /[?*]/;
export const DESTINATION_FILENAME_ERROR = i18n.t('Should not contain "*" or "?" characters.');
export const DESTINATION_FILENAME_ERROR_LONG = i18n.t(
   'Destination filename should not contain "*" or "?" characters.'
);
export const isDestinationFilenameValid = (name: string) => {
   return !invalidChars.test(name);
};
